module.exports = __webpack_public_path__ + "img/fig19.7a413f8f.jpg";